import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/EarningsSnapshot';

export const EARNINGS_SNAPSHOT_VIEW = `${rootActionPath}/VIEW`;
export const EARNINGS_SNAPSHOT_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const EARNINGS_SNAPSHOT_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
